export const calcTotalPrice = (sum: number, discount?: number): number => {
  const valueWithDiscount = sum + (sum * (discount ?? 0)) / 100;

  // нам нужна эта проверка, иначе в некоторых кейсах получается intermediate value
  // у которого просто отсутствует метод toFixed и страница падает
  if (typeof valueWithDiscount !== 'number') {
    return 0;
  }

  return Number.parseFloat(valueWithDiscount.toFixed(2));
};
